import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

const TOKEN_KEY = "lakeze_token";
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });
client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// ---- Public ----
export const submitSurvey = (form) => client.post("/surveys", form).then((r) => r.data);
export const createSession = () => client.post("/sessions").then((r) => r.data);
export const updateSession = (id, payload) => client.put(`/sessions/${id}`, payload).then((r) => r.data);
export const track = (event) => client.post("/track", { event }).then((r) => r.data).catch(() => {});

// ---- Admin auth ----
export const login = (email, password) =>
  client.post("/admin/login", { email, password }).then((r) => r.data);
export const changePassword = (oldPassword, newPassword) =>
  client.post("/admin/change-password", { oldPassword, newPassword }).then((r) => r.data);

// ---- Admin data ----
export const getStats = () => client.get("/admin/stats").then((r) => r.data);

export const getHealth = () => {
  const start = performance.now();
  return client.get("/admin/health").then((r) => {
    const rtt = Math.round(performance.now() - start);
    return { ...r.data, api: { status: "ok", latencyMs: rtt } };
  });
};
export const getAnalytics = () => client.get("/admin/analytics").then((r) => r.data);
export const listSurveys = (params) =>
  client.get("/admin/surveys", { params }).then((r) => r.data);
export const listSessions = (params) =>
  client.get("/admin/sessions", { params }).then((r) => r.data);
export const resendSurvey = (id) => client.post(`/admin/surveys/${id}/resend`).then((r) => r.data);
export const deleteSurvey = (id) => client.delete(`/admin/surveys/${id}`).then((r) => r.data);

// ---- Ads ----
export const getAds = () => client.get("/admin/ads").then((r) => r.data);
export const createAd = (ad) => client.post("/admin/ads", ad).then((r) => r.data);
export const updateAd = (id, ad) => client.put(`/admin/ads/${id}`, ad).then((r) => r.data);
export const removeAd = (id) => client.delete(`/admin/ads/${id}`).then((r) => r.data);

// ---- Notification settings ----
export const getNotifySettings = () => client.get("/admin/notify-settings").then((r) => r.data);
export const updateNotifySettings = (payload) =>
  client.put("/admin/notify-settings", payload).then((r) => r.data);
export const sendNotificationNow = () =>
  client.post("/admin/send-daily-notification").then((r) => r.data);

export default client;
